// extracted by mini-css-extract-plugin
export default {"mobileNav":"MobileNav2_mobileNav__yMoLZ","hide":"MobileNav2_hide__Ygi0T"};